<template>
  <v-dialog v-model="show">
    <v-card class="mt-2">
      <v-card-title primary-title>
        <span class="headline mb-0">倉庫別指示者追加</span>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="!valid" @click="save">{{
          $t('app.buttons.save')
        }}</v-btn>
        <v-btn @click="back">{{ $t('app.buttons.back') }}</v-btn>
      </v-card-actions>
      <v-form v-model="valid">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs3>
              <remote-autocomplete
                :label="$t('app.labels.bu.name')"
                :rules="[
                  (v) =>
                    !!v ||
                    $t('app.labels.bu.name') +
                      $t('app.validator.messages.required'),
                ]"
                return-object
                :url="`divisions/kv?type=BU&companyId=${companyId}`"
                v-model="query.bu"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="BU"
                return-object
                url="divisions/kv?type=BUSINESS_UNIT"
                v-model="query.businessUnitId"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="倉庫別納入指示担当1"
                return-object
                url="employees/kv?types=SHARP,SJL"
                v-model="query.deliveryDirectorId1"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="倉庫別納入指示担当2"
                return-object
                url="employees/kv?types=SHARP,SJL"
                v-model="query.deliveryDirectorId2"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="倉庫別納入指示担当3"
                return-object
                url="employees/kv?types=SHARP,SJL"
                v-model="query.deliveryDirectorId3"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="倉庫別納入指示担当4"
                return-object
                url="employees/kv?types=SHARP,SJL"
                v-model="query.deliveryDirectorId4"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="倉庫別納入指示担当5"
                return-object
                url="employees/kv?types=SHARP,SJL"
                v-model="query.deliveryDirectorId5"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="倉庫別納入指示担当6"
                return-object
                url="employees/kv?types=SHARP,SJL"
                v-model="query.deliveryDirectorId6"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="倉庫別納入指示担当7"
                return-object
                url="employees/kv?types=SHARP,SJL"
                v-model="query.deliveryDirectorId7"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="倉庫別納入指示担当8"
                return-object
                url="employees/kv?types=SHARP,SJL"
                v-model="query.deliveryDirectorId8"
              ></remote-autocomplete>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ['companyId', 'accRepeat'],
  data() {
    return {
      query: {},
      show: false,
      valid: false,
      // buUrl: `divisions/kv?type=BU&&companyId=${this.companyId}`,
      // departmentUrl: `divisions/kv?type=DEPARTMENT&&companyId=${
      //   this.companyId
      // }`,
      // employeeUrl: `employees/kv?companyId=${this.companyId}`
    }
  },
  methods: {
    popup() {
      this.show = true
    },
    save() {
      if (this.accRepeat(this.query)) return
      this.$http
        .post(`/companies/${this.companyId}/add-warehouse-delivery-acc`, {
          buId: this.getValue(this.query.bu),
          departmentId: this.getValue(this.query.department),
          businessUnitId: this.getValue(this.query.businessUnitId),
          classificationId: this.getValue(this.query.classification),
          deliveryDirectorId1: this.getValue(this.query.deliveryDirectorId1),
          deliveryDirectorId2: this.getValue(this.query.deliveryDirectorId2),
          deliveryDirectorId3: this.getValue(this.query.deliveryDirectorId3),
          deliveryDirectorId4: this.getValue(this.query.deliveryDirectorId4),
          deliveryDirectorId5: this.getValue(this.query.deliveryDirectorId5),
          deliveryDirectorId6: this.getValue(this.query.deliveryDirectorId6),
          deliveryDirectorId7: this.getValue(this.query.deliveryDirectorId7),
          deliveryDirectorId8: this.getValue(this.query.deliveryDirectorId8),
        })
        .then(() => {
          this.$emit('refresh')
          this.show = false
        })
    },

    getValue(data) {
      return data && data.value
    },

    back() {
      this.query = {}
      this.show = false
    },
  },
}
</script>
